/**
 * CSV for the usage report's tables.
 *
 * One writer for every export on the page, so the two things a spreadsheet
 * gets wrong by default are handled once rather than per table.
 */

export type CsvValue = string | number | null | undefined;

/**
 * One CSV field.
 *
 * Quoted when it has to be, and defused when it starts with a character a
 * spreadsheet would run as a formula: these are names and emails that
 * customers typed, and the file is going to be opened in Excel.
 */
function csvField(value: CsvValue) {
  let text = value === null || value === undefined ? '' : String(value);
  if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`;
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Saves rows as a file. The first row is the header. */
export function downloadCsv(filename: string, rows: CsvValue[][]) {
  const lines = rows.map((row) => row.map(csvField).join(','));

  // The BOM is what makes Excel read the file as UTF-8 rather than mangle
  // every accented name in it.
  const blob = new Blob(['﻿', lines.join('\r\n')], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Without this the blob is held for the life of the document.
  URL.revokeObjectURL(url);
}

/**
 * A share as a spreadsheet wants it: a plain fraction, four places.
 *
 * Not the "12.3%" the page prints. That is text to Excel, and a column of it
 * can be neither summed nor sorted.
 */
export function csvShare(fraction: number) {
  return Number(fraction.toFixed(4));
}
